"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
/**
 * NOTE: This is not nearly as efficient as being instructed from the server-
 * side where matches are and how to replace them. A future iteration should
 * move highlighting to the server.
 */
exports.default = ({ text, search, className = "highlight", }) => {
    // eslint-disable-next-line security-node/non-literal-reg-expr
    const re = new RegExp(`(${search})`, "gi");
    // React won't properly handle replacing substrings with components, hence the
    // following dance.
    const tagged = text.replace(re, `||$1||`);
    const parts = tagged.split("||");
    for (let i = 0; i < parts.length; i += 1) {
        if (parts[i].match(re)) {
            parts[i] = (react_1.default.createElement("span", { className: className, key: `match-${search}-${i}` }, parts[i]));
        }
    }
    return react_1.default.createElement(react_1.default.Fragment, null, parts);
};
